import SearchHelper from './pages/SearchHelper';
import SearchResult from './pages/SearchResult';
import type { ScreenItem } from 'shared/src/types';

export type SearchStackParamList = {
  SearchHelper: {
    instanceId?: string;
    query?: string;
    delivery_type?: string;
    show_keyboard?: string;
    search_type?: string;
    from_screen?: string;
    filter_token?: string;
    /** queryParams에서 전달되는 추가 파라미터 */
    [key: string]: string | number | boolean | undefined;
  };
  SearchResult: {
    instanceId?: string;
    query?: string;
    delivery_type?: string;
    search_type?: string;
    filter_token?: string;
    /** SearchHelper의 instanceId (복귀 시 데이터 전달용) */
    from_instance_id?: string;
    /** 로깅용 진입 화면 (API 미전달) */
    from_screen?: string;
    /** queryParams에서 전달되는 추가 파라미터 */
    [key: string]: string | number | boolean | undefined;
  };
};

export const SearchScreens: ScreenItem[] = [
  {
    name: 'SearchHelper',
    component: SearchHelper,
    path: '/search/search-helper',
    options: {
      title: '검색 보조',
    },
    convertParams: props => {
      const extras = Array.isArray(props.extras)
        ? props.extras[0]
        : props.extras;

      return {
        instanceId: props.instanceId,
        ...(typeof extras === 'string' ? JSON.parse(extras) : extras),
      };
    },
  },
  {
    name: 'SearchResult',
    component: SearchResult,
    path: '/search/search-result',
    options: {
      title: '검색 결과',
    },
    convertParams: props => {
      const extras = Array.isArray(props.extras)
        ? props.extras[0]
        : props.extras;

      return {
        instanceId: props.instanceId,
        ...(typeof extras === 'string' ? JSON.parse(extras) : extras),
      };
    },
  },
];
